// 120+ tipos de fuente (Google Fonts) para el editor de credenciales.
export const CREDENTIAL_FONTS = [
  "Inter", "Roboto", "Open Sans", "Lato", "Montserrat", "Poppins", "Raleway", "Oswald",
  "Merriweather", "Nunito", "Nunito Sans", "Playfair Display", "PT Sans", "PT Serif",
  "Source Sans 3", "Source Serif 4", "Ubuntu", "Rubik", "Work Sans", "Mulish", "Karla",
  "Quicksand", "Josefin Sans", "Bebas Neue", "Anton", "Archivo", "Archivo Black", "Barlow",
  "Barlow Condensed", "Cabin", "Catamaran", "Comfortaa", "Cormorant", "Cormorant Garamond",
  "DM Sans", "DM Serif Display", "Dosis", "Exo 2", "Fira Sans", "Fjalla One", "Heebo",
  "Hind", "Inconsolata", "Jost", "Kanit", "Lexend", "Libre Baskerville", "Libre Franklin",
  "Lobster", "Manrope", "Marcellus", "Maven Pro", "Muli", "Noto Sans", "Noto Serif",
  "Overpass", "Pacifico", "Passion One", "Pathway Gothic One", "Permanent Marker",
  "Philosopher", "Play", "Prompt", "Questrial", "Righteous", "Sacramento", "Satisfy",
  "Signika", "Space Grotesk", "Space Mono", "Spectral", "Teko", "Titillium Web", "Varela Round",
  "Vollkorn", "Yanone Kaffeesatz", "Zilla Slab", "Abril Fatface", "Alfa Slab One", "Amatic SC",
  "Arvo", "Asap", "Assistant", "Bitter", "Cairo", "Changa", "Chakra Petch", "Crimson Text",
  "Domine", "Eczar", "El Messiri", "Faustina", "Frank Ruhl Libre", "Gelasio", "Gothic A1",
  "Great Vibes", "Hepta Slab", "IBM Plex Sans", "IBM Plex Serif", "IBM Plex Mono", "Italiana",
  "Judson", "Julius Sans One", "Khand", "Lora", "Marck Script", "Martel", "Mochiy Pop One",
  "Monoton", "Montserrat Alternates", "Neuton", "Orbitron", "Oxygen", "Padauk", "Piazzolla",
  "Podkova", "Prata", "Red Hat Display", "Rokkitt", "Rozha One", "Saira", "Saira Condensed",
  "Sanchez", "Secular One", "Sen", "Shadows Into Light", "Sora", "Staatliches", "Tajawal",
  "Tinos", "Unbounded", "Urbanist", "Vazirmatn", "Yellowtail", "Yeseva One",
];

const loaded = new Set();
export function loadFont(family) {
  if (!family || loaded.has(family)) return;
  loaded.add(family);
  const id = "gf-" + family.replace(/\s+/g, "-").toLowerCase();
  if (document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(family)}:wght@400;600;700;900&display=swap`;
  document.head.appendChild(link);
}
